import React from "react";
import Widget from "../widget/Widget";
import { SchoolOutlined } from "@mui/icons-material";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

export const TopWidgetsStudent = ({ data }) => {
  const schoolCount = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(data.school_count);
  const studentCount = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(data.total_app_student_cnt);
  const enrollmentCount = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(data.total_crs_enrollment_cnt);
  const exerciseCount = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(data.total_excs_cnt);

  return (
    <div className="top-widgets-students-container flex gap-2">
      <Widget
        title="Schools"
        number={schoolCount}
        link="View schools"
        diff={40}
        icon={
          <SchoolOutlined
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Students"
        number={studentCount}
        link=""
        diff={40}
        icon={
          <LocalLibraryIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Enrollments"
        number={enrollmentCount}
        link=""
        diff={22}
        icon={
          <CardMembershipIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Exercise"
        number={exerciseCount}
        link=""
        diff={40}
        icon={
          <FitnessCenterIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
    </div>
  );
};
